import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Field, Form, submit, reduxForm } from 'redux-form/immutable';
import Grid from '@material-ui/core/Grid';

import Button from '@material-ui/core/Button';
import { renderTextField } from '../../../../utils/reduxforms';

import ReduxDialog from '../../../Common/ReduxDialog/index';
import { required } from '../../../../utils/formvalidation';
import { hideDialog } from '../../../../redux/actions/dialogs';

import { saveRoleFormHandler } from '../../../../redux/routines';

import styles from './styles';
import { ROLE_DIALOG } from '../../../../redux/constants/dialogs';
import { getDialogContextValue } from '../../../../redux/selectors';

class RoleDialog extends React.Component {
  render() {
    const { handleSubmit, submit, hideDialog } = this.props;
    const actions = [
      <Button
        key="cancel"
        variant="text"
        color="primary"
        onClick={() => hideDialog(ROLE_DIALOG)}
      >Cancel</Button>,
      <Button
        key="save"
        variant="contained"
        color="primary"
        autoFocus
        onClick={() => submit()}
      >Save</Button>,
    ];

    return (
      <ReduxDialog
        name={ROLE_DIALOG}
        title="Role"
        actions={actions}
        autoScrollBodyContent
        maxWidth="sm"
        fullWidth
      >
        <Form onSubmit={handleSubmit(saveRoleFormHandler)} style={styles.form}>
          <Grid container spacing={8}>
            <Grid item xs>
              <Field
                name="name"
                component={renderTextField}
                label="Name"
                fullWidth
                validate={[required]}
              />
            </Grid>
          </Grid>
        </Form>
      </ReduxDialog>
    );
  }
}

RoleDialog.propTypes = {
};

const form = reduxForm({
  form: ROLE_DIALOG,  // a unique identifier for this form
  onSubmitSuccess: (result, dispatch, props) => {
    props.hideDialog(ROLE_DIALOG);
  },
  onSubmitFail: (err) => {
    console.log('onSubmitFail', err);
  },
})(RoleDialog);

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    submit,
    hideDialog,
  }, dispatch);
}

function mapStateToProps(state, props) {
  return {
    initialValues: getDialogContextValue(state)(ROLE_DIALOG, 'role'),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(form);


// WEBPACK FOOTER //
// ./src/components/Admin/Roles/RoleDialog/index.js